import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../environments/environment';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'roteiros-ocorrencias-dashboard-card',
    templateUrl: './roteiros-ocorrencias-dashboard-card.component.html',
    styleUrls: ['./roteiros-ocorrencias-dashboard-card.component.css'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass]
})
export class RoteirosOcorrenciasDashboardCardComponent implements OnInit {

  urlOcorrencias = '';
  @Input() ocorrencias;
  @Input() totaisOcorrencias;
  dadosOcorrencias = [];

  todaOcorrenciaFiltro: any;

  constructor() { }

  ngOnInit() {
    this.urlOcorrencias = environment.url_telaOcorrencias + '/index.html' + window.location.search;
    this.todaOcorrenciaFiltro = this.ocorrencias;
    this.iniciaDadosOcorrencia();
  }

  abrirOcorrencias(ocorrencia){
    const opc6 = {roteiro: ocorrencia.NumeroRoteiro }
    const novaData = btoa(new Date().getUTCFullYear() + '-' + (new Date().getUTCMonth() + 1) + '-' + new Date().getUTCDate() + " " + new Date().getHours() + ":" + new Date().getMinutes());
    const analisaUrl = new URL(this.urlOcorrencias);
    analisaUrl.searchParams.set("opc4", novaData);
    const finalUrl = analisaUrl.toString();
    window.open(finalUrl + `&opc6=${btoa(JSON.stringify(opc6))}`, "_blank");
  }

  atualizaOcorrencia(roteiros: any[]){
    this.ocorrencias = this.todaOcorrenciaFiltro.filter((roteiro) => roteiros.includes(roteiro.NumeroRoteiro))

    this.totaisOcorrencias.emAberto = this.ocorrencias.reduce((preVal, elem) => preVal + elem.emAberto, 0);
    this.totaisOcorrencias.emAnalise = this.ocorrencias.reduce((preVal, elem) => preVal + elem.emAnalise, 0);
    this.totaisOcorrencias.finalizadas = this.ocorrencias.reduce((preVal, elem) => preVal + elem.finalizadas, 0);
    this.iniciaDadosOcorrencia();
  }

  iniciaDadosOcorrencia(){
    this.dadosOcorrencias = [
      {descricao: 'Em Aberto', img: 'assets/img/ocorrencia_aberta.svg', bgColor : 'bg-em-aberto', qtdOcorrencia : this.totaisOcorrencias.emAberto },
      {descricao: 'Em avaliação', img: 'assets/img/ocorrencia_avaliacao.svg', bgColor : 'bg-em-analise', qtdOcorrencia : this.totaisOcorrencias.emAnalise },
      {descricao: 'Finalizadas', img: 'assets/img/ocorrencia_finalizada.svg', bgColor : 'bg-finalizadas', qtdOcorrencia : this.totaisOcorrencias.finalizadas }
    ]
  }
}
